import React from "react";
import PropTypes from "prop-types";

import "./StatusIndicator.css";

export default class StatusIndicator extends React.Component {
  
  static propTypes = {
    color: PropTypes.string.isRequired,
    label: PropTypes.node,
    iconContent: PropTypes.node
  }
  
  render() {
    const { color, label, iconContent } = this.props;
    const hasIconContent = iconContent !== undefined;
    const iconStyle = {
      backgroundColor: hasIconContent ? undefined : color,
      borderColor: color
    };
    return (
      <div className="status-indicator">
        <span className="status-indicator__icon" style={iconStyle}>{iconContent}</span>
        <span className="status-indicator__label">{label}</span>
      </div>
    )
  }
  
}



// WEBPACK FOOTER //
// ./src/components/school_money/history/StatusIndicator.js